import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover"]

  connect() {
    // Close popover when clicking outside
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.popoverTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.popoverTarget.classList.remove('hidden')
    // Add listener to close when clicking outside
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 0)
  }

  close() {
    this.popoverTarget.classList.add('hidden')
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }
}
